__turbopack_context__.v({
  "className": "sora_1699487f-module__XVxUna__className",
  "variable": "sora_1699487f-module__XVxUna__variable",
});
